import { DropdownButton } from 'react-bootstrap';
import { BsJournals } from 'react-icons/bs';
import TextIcon from '../../components/textIcon';
import SavedQuery from './savedQuery';

// interface ISavedQueriesProps extends React.AllHTMLAttributes<HTMLDivElement> {}
const SavedQueries = () => {
	return (
		<DropdownButton
			variant="secondary"
			title={
				<TextIcon Icon={BsJournals} inline>
					<span className="d-none d-xl-inline">Запити</span>
				</TextIcon>
			}
			id="ddSavedQueries"
			align="end"
		>
			{SAVED_QUERIES.map(({ title, key_words }) => (
				<SavedQuery key={title} title={title} term={key_words.join(' ')} />
			))}
		</DropdownButton>
	);
};

export default SavedQueries;

interface ISavedQuery {
	title: string;
	key_words: string[];
}
const SAVED_QUERIES: ISavedQuery[] = [
	{
		title: 'Президент України',
		key_words: [
			'"Президент України"',
			'"Президент Украины"',
			'"Президент Зеленський"',
			'"Президент Зеленский"',
			'"Володимир Зеленський"',
			'"Владимир Зеленский"',
		],
	},
	{
		title: 'СБУ',
		key_words: [
			`СБУ УСБУ "Служба безпеки України" "Служба безопасности Украины" "СБ України" "СБ Украины" "Олександр Поклад" "Александр Поклад" "Андрій Тупіков" "Андрей Тупиков" "Ярослав Мережко" "Денис Килимник" "Іван Рудницький" "Иван Рудницкий" "Василь Малюк" "Василий Малюк" "Олег Федорів" "Олег Федорив" "Олег Федоров" "Центр спеціальних операцій А" "Центр специальных операций А" "ЦСО А" "ЦСО Альфа" "Департамент контррозвідки" "Департамент контрразведки" "Департамент військової контррозвідки" "Департамент военной контрразведки" "військова контррозвідка" "военная контрразведка" "Департамент кібербезпеки" "Департамент кибербезопасности" "Ситуаційний центр забезпечення кібербезпеки" "Ситуационный центр обеспечения кибербезопасности" "Об'єднаний центр з координації пошуку та звільнення незаконно позбавлених волі осіб" "Объединенный центр по координации поиска и освобождения незаконно лишенных свободы лиц" "операція Павутина" "операция Паутина" "спецоперація Павутина"~2 "спецоперация Паутина"~2 "Sea Baby" SeaBaby "Sub SeaBaby" "Sub Sea Baby"`,
		],
	},
	{
		title: 'ЗСУ',
		key_words: [
			'ЗСУ',
			'ВСУ',
			'"Збройні Сили України"',
			'"оперативне командування"',
			'"Вооруженные Силы Украины"',
			'Сирський',
		],
	},
];
